<template>
  <el-dialog
    title="設定錄音流通管理員"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                size="small"
                v-model="queryForm.qstr"
                placeholder="帳號、名稱"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchJoin"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次指派</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchQuit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次解除</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 錄音流通：{{ recshareName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            @selection-change="handleSelectionChange"
            :data="users"
            @sort-change="sortChange"
            :default-sort="{ prop: 'id', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="帳號"
              prop="username"
              sortable="custom"
              width="170"
            >
            </el-table-column>

            <el-table-column
              label="名稱"
              prop="name"
              sortable="custom"
              width="200"
            >
            </el-table-column>

            <el-table-column label="擔任錄音流通管理員" width="170px">
              <template #default="scope">
                <el-switch
                  :value="isRecshareAdmin(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index) || isOrgAdmin(scope.row)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    isAdmin => setAdmin(isAdmin, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column label="擔任單位管理員">
              <template #default="scope">
                <span v-if="isOrgAdmin(scope.row)">
                  <img
                    src="../../assets/icons/success.svg"
                    class="successicon"
                  />
                </span>
              </template>
            </el-table-column>

          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import { mapGetters } from "vuex";
import { ORG_ADMIN_ROLE } from '../../appConfig';
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    recshareId: {
      type: Number,
    },
    recshareName: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      users: "user/users",
      total: "user/total",
      offset: "user/offset",
      sort: "user/sort",
      order: "user/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      isLoading: false,
      disabledSwitchIdx: [],
      selectedRow: [],
      pageSize: 50,
      formLabelWidth: "100px",
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    this.$store.commit("user/CLEAR");
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedName => {
              const failedOne = this.users.find(
                item => item.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = row => ((this.isOrgAdmin(row) || this.isRecshareAdmin(row)) ? true : false);
      this.batchHandler(isSkipped, this.beAdmin.bind(this), "批次指派成功");
    },
    handleBatchQuit() {
      const isSkipped = row => ((this.isOrgAdmin(row) || !this.isRecshareAdmin(row)) ? true : false);
      this.batchHandler(isSkipped, this.beNotAdmin.bind(this), "批次解除成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    setAdmin(isAdmin, usr, index) {
      const isChecked = this.selectedRow.find(row => row.name === usr.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (isAdmin) {
        p = this.beAdmin(usr, index);
      } else {
        p = this.beNotAdmin(usr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.users[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    beAdmin(usr, index, updateStore = true, showMsg = true) {
      const params = {};
      params.recshareId = this.recshareId;
      params.userId = usr.id;
      return API.recshareUser.add(params).then(res => {
        if (updateStore) {
          const newUsr = { ...usr };
          const recshareUsers = [{}];
          recshareUsers[0].id = res.data.id;
          newUsr.recshareUsers = recshareUsers;

          const payload = {};
          payload.newElem = newUsr;
          payload.index = index;
          this.$store.commit("user/CHANGE_ELEMENT", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "加入成功!",
          });
      });
    },

    beNotAdmin(usr, index, updateStore = true, showMsg = true) {
      return API.recshareUser.remove(usr.recshareUsers[0].id).then(() => {
        if (updateStore) {
          const newUsr = { ...usr };
          newUsr.recshareUsers = [];

          const payload = {};
          payload.newElem = newUsr;
          payload.index = index;
          this.$store.commit("user/CHANGE_ELEMENT", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "移除成功!",
          });
      });
    },

    isOrgAdmin(usr) {
      return usr.roles.includes(ORG_ADMIN_ROLE);
    },

    isRecshareAdmin(usr) {
      if (this.isOrgAdmin(usr)) {
        return true;
      }
      else {
        return usr.recshareUsers.length > 0 ? true : false;
      }
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },

    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },

    query(max, offset, sort, order, params = {}) {
      return this.$store
        .dispatch("user/list", {
          max: max,
          offset: offset,
          sort,
          order,
          recshare: this.recshareId,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("user/SET_SORT", "id");
        this.$store.commit("user/SET_ORDER", "ascending");
      } else {
        this.$store.commit("user/SET_SORT", args.prop);
        this.$store.commit("user/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      //this.$store.dispatch("recshareUser/list", null);
    },
  },
};
</script>

<style scoped>
.successicon {
  width: 20px;
  height: 20px;
  margin-left: 28px;
  margin-right: 2px;
}
</style>
